"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Upgrade/ChatNotice/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _upgrade = require('shared/enum/upgrade');
var _upgradeNotices = require('shared/constants/upgradeNotices');





var _conversation = require('shared/selectors/conversation');
var _org = require('shared/selectors/org');
var _user = require('shared/selectors/user');
var _useToggle = require('shared/hooks/useToggle'); var _useToggle2 = _interopRequireDefault(_useToggle);




var _freeCapAnalytics = require('web/services/freeCapAnalytics');
var _hooks = require('web/services/hooks');

var _View = require('./View'); var _View2 = _interopRequireDefault(_View);
var _UpgradeModal = require('web/components/Upgrade/UpgradeModal'); var _UpgradeModal2 = _interopRequireDefault(_UpgradeModal);





const ChatUpgradeNotice = ({ blobjectKey }) => {
  // The old mapState returned {} (every value undefined) without a blobjectKey.
  const orgKey = _hooks.useAppSelector.call(void 0, state =>
    blobjectKey ? _conversation.selectMyOrgKeyInConvo.call(void 0, state, blobjectKey) : undefined)
  const isOverInternalChatLimit = _hooks.useAppSelector.call(void 0, state =>
    blobjectKey ? _conversation.selectShouldShowUpgradeNotice.call(void 0, state, blobjectKey) : undefined)
  const isOverPatientChatLimit = _hooks.useAppSelector.call(void 0, state =>
    blobjectKey ? _conversation.selectShouldShowPatientUpgradeNotice.call(void 0, state, blobjectKey) : undefined)
  // Each selector looks up the org key itself, so it never reads a stale one.
  const amIAdmin = _hooks.useAppSelector.call(void 0, state => {
    if (!blobjectKey) return undefined
    const key = _conversation.selectMyOrgKeyInConvo.call(void 0, state, blobjectKey)
    return !!key && _user.selectAmIAdminInOrg.call(void 0, state, key)
  })
  const activeMemberCount = _hooks.useAppSelector.call(void 0, state => {
    if (!blobjectKey) return undefined
    const key = _conversation.selectMyOrgKeyInConvo.call(void 0, state, blobjectKey)
    const org = key ? _org.selectOrgV1.call(void 0, state, key) : null
    return _optionalChain([org, 'optionalAccess', _ => _.NumberOfMembers])
  })
  const { isOpen, onOpen, onClose } = _useToggle2.default.call(void 0, )
  const trackedImpressionKey = _react.useRef(null)

  const analyticsContext = _react.useMemo.call(void 0, 
    () => {
      if (!isOverInternalChatLimit || isOverPatientChatLimit || !orgKey) {
        return null
      }

      return {
        source: _freeCapAnalytics.FREE_CAP_ANALYTICS_SOURCE,
        orgKey,
        activeMemberCount,
        freeCap: _upgradeNotices.OVER_LIMIT_MEMBERS_THRESHOLD,
        isAdmin: !!amIAdmin,
      }
    },
    [
      activeMemberCount,
      amIAdmin,
      isOverInternalChatLimit,
      isOverPatientChatLimit,
      orgKey,
    ],
  )

  _react.useEffect.call(void 0, 
    () => {
      if (!analyticsContext) return

      const impressionKey = [
        blobjectKey,
        analyticsContext.orgKey,
        analyticsContext.activeMemberCount,
        analyticsContext.isAdmin ? 'admin' : 'non_admin',
      ].join(':')
      if (trackedImpressionKey.current === impressionKey) return

      _freeCapAnalytics.trackFreeCapLockedChatShown.call(void 0, analyticsContext)
      trackedImpressionKey.current = impressionKey
    },
    [analyticsContext, blobjectKey],
  )

  const handleProceed = _react.useCallback.call(void 0, 
    () => {
      if (analyticsContext) {
        _freeCapAnalytics.trackFreeCapLockedChatUpgradeClicked.call(void 0, analyticsContext)
      }
      onOpen()
    },
    [analyticsContext, onOpen],
  )

  if (!orgKey || !isOverInternalChatLimit && !isOverPatientChatLimit) return null

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_View2.default, {
        amIAdmin: amIAdmin,
        isPatientNotice: isOverPatientChatLimit,
        onProceed: handleProceed, __self: this, __source: {fileName: _jsxFileName, lineNumber: 107}}
      )
      , _react2.default.createElement(_UpgradeModal2.default, {
        isOpen: isOpen,
        onClose: onClose,
        orgKey: orgKey,
        analyticsContext: analyticsContext || undefined,
        type: isOverPatientChatLimit
          ? _upgrade.SubscriptionItemType.SMS
          : _upgrade.SubscriptionItemType.TEAM
        , __self: this, __source: {fileName: _jsxFileName, lineNumber: 112}}
      )
    )
  )
}

exports. default = _react.memo.call(void 0, ChatUpgradeNotice)
